// 上面的搜索框的 placeholder 配置
export const inputPlaceholderOptions = {
  name: '代理名称',
  phone: '联系方式',
  taskName: '任务名称',
  taskState: '任务状态'
}

// 可以搜索的状态
export const taskStatusOptions = [
  {
    label: '待承接',
    value: 3
  },
  {
    label: '已承接',
    value: 4
  },
  {
    label: '已拒接',
    value: 5
  },
  {
    label: '已关闭',
    value: 6
  }
  // {
  //   label: '已完成',
  //   value: 7
  // }
]

// 表格列的名字配置
export const tableColumnNameOptions = {
  name: '代理名称',
  concat: '联系方式',
  taskName: '任务名称',
  taskStatus: '任务状态',
  settleMode: '结算方式',
  expectedQuantity: '数量',
  unitPriceYuan: '单价',
  taskEndTime: '任务截止时间',
  // count: '答卷数量',
  // price: '答卷单价',
  commitCount: '提交数量',
  effectiveCount: '有效数量',
  switch: '任务开关'
}

export const newFieldOptions = {
  taskName: 'taskName',
  endTime: 'endTime',
  count: 'requireCount',
  price: 'unitPrice'
}
